import {
} from './actions'
import {
  SET_SCROLL_POSITION
} from './mutations'

const state = {
  scrollPosition: null
}

const getters = {
  scrollPosition (state) {
    return state.scrollPosition
  }
}

const actions = {
}

const mutations = {
  [SET_SCROLL_POSITION] (state, data) {
    state.scrollPosition = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
